import React from "react";

/**
 * Top-10 Ranking list. Winner is rendered with emphasis.
 */
const RANKING = [
  { rank: 1, name: "BUDDIEZ buns & rolls", district: "Ost · Werderstr. 79", score: 9.7, note: "Gesamtsieger" },
  { rank: 2, name: "Burgermeister", district: "Stadtmitte", score: 9.2, note: "Klassiker-Champion" },
  { rank: 3, name: "Hob's Burger", district: "Bad Cannstatt", score: 9.0, note: "Top Patty" },
  { rank: 4, name: "Goldies", district: "Stuttgart", score: 8.8, note: "Beste Sauce" },
  { rank: 5, name: "Bo's Burger", district: "West", score: 8.6, note: "Bester Bun" },
  { rank: 6, name: "Smash it Burger", district: "Bad Cannstatt", score: 8.4, note: "Smashed Fav" },
  { rank: 7, name: "Better Burger Company", district: "Mitte", score: 8.2, note: "Zuverlässig gut" },
  { rank: 8, name: "Meatery", district: "Ost", score: 8.0, note: "Dry Aged Kick" },
  { rank: 9, name: "Mrs. Wood", district: "Mitte", score: 7.9, note: "Brioche-Freund" },
  { rank: 10, name: "Hans im Glück", district: "Königstr.", score: 7.6, note: "Solider Klassiker" },
];

export default function RankingList() {
  return (
    <ol className="space-y-2" data-testid="ranking-list">
      {RANKING.map((r) => {
        const isWinner = r.rank === 1;
        return (
          <li
            key={r.rank}
            className={`rank-row grid grid-cols-12 gap-2 sm:gap-4 items-center px-4 sm:px-5 py-4 border ${
              isWinner
                ? "border-[#E8B14A]/60 bg-gradient-to-r from-[#E8B14A]/10 via-transparent to-transparent"
                : "border-zinc-900"
            } rounded-sm`}
            data-testid={`rank-${r.rank}`}
          >
            <div className="col-span-2 sm:col-span-1">
              <div
                className={`font-editorial text-2xl sm:text-3xl leading-none ${
                  isWinner ? "text-[#E8B14A]" : "text-zinc-500"
                }`}
              >
                {String(r.rank).padStart(2, "0")}
              </div>
            </div>
            <div className="col-span-7 sm:col-span-7">
              <div className={`text-base sm:text-lg font-semibold ${isWinner ? "text-white" : "text-zinc-200"}`}>
                {r.name}
                {isWinner && (
                  <span className="ml-2 inline-block align-middle px-2 py-0.5 text-[10px] font-mono-accent uppercase tracking-[0.25em] bg-[#E8B14A] text-black rounded-[2px]">
                    Sieger
                  </span>
                )}
              </div>
              <div className="text-xs text-zinc-500 mt-1">
                {r.district} · <span className="text-zinc-400">{r.note}</span>
              </div>
            </div>
            <div className="col-span-3 sm:col-span-4 text-right">
              <span
                className={`font-editorial tabular-nums ${
                  isWinner ? "text-[#E8B14A] text-3xl sm:text-4xl" : "text-zinc-300 text-xl sm:text-2xl"
                }`}
              >
                {r.score.toFixed(1)}
              </span>
              <span className="text-zinc-600 text-xs ml-1">/ 10</span>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
